export default __webpack_public_path__ + "static/media/ts6.2d1561ae.png";